import Cookies from 'js-cookie';
const { TokenKey, UserIdKey, AccountKey, CookiesExpires } = require('@/settings');

// token
export function getToken() {
  return Cookies.get(TokenKey);
}

export function setToken(token) {
  return Cookies.set(TokenKey, token, { expires: CookiesExpires });
}

export function removeToken() {
  return Cookies.remove(TokenKey);
}

// 用户id
export function getUserId() {
  return Cookies.get(UserIdKey);
}

export function setUserId(id) {
  return Cookies.set(UserIdKey, id, { expires: CookiesExpires });
}

export function removeUserId() {
  return Cookies.remove(UserIdKey);
}

// 记住密码
export function getRememberAccount() {
  return Cookies.get(AccountKey);
}

export function setRememberAccount(account) {
  return Cookies.set(AccountKey, account, { expires: CookiesExpires });
}

export function removeRememberAccount() {
  return Cookies.remove(AccountKey);
}
